import { render, staticRenderFns } from "./leecheros.vue?vue&type=template&id=3f30a5a7"
import script from "./leecheros.vue?vue&type=script&lang=js"
export * from "./leecheros.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports